
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/expulsats-de-barcelona",
      function () {
        return require("private-next-pages/3catinfo/expulsats-de-barcelona/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/expulsats-de-barcelona"])
      });
    }
  